import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home/:id?/:hashKey?',
        name: 'Home',
        component: () => import('./views/Home.vue'),
    },
    {
        path: '/acerca-de',
        name: 'About',
        component: () => import('./views/About.vue'),
    },
    {
        path: '/terminos-y-condiciones',
        name: 'TermsAndConditions',
        component: () => import('./views/TermsAndConditions.vue'),
    },
    {
        path: '/mi-cuenta/:section?',
        name: 'MyAccount',
        component: () => import('./views/MyAccount.vue'),
    },
    {
        path: '/compatibilidad', 
        component: () => import('./views/compatibility/index.vue'), 
        meta: { title: "Compatibilidad" },
        children: [
            {
                path: '/',
                name: 'Compatibility',
                component: () => import('./views/compatibility/imei.vue'),
                meta: { title: 'Verificación por IMEI | Compatibilidad' }
            },
            {
                path: 'dispositivos',
                component: () => import('./views/compatibility/devices.vue'),
                meta: { title: 'Dispositivos compatibles | Compatibilidad' }
            },
        ]
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: () => import('./views/NotFound.vue'),
    },
    {
        path: '/portabilidad', 
        name: 'Portability',
        redirect: '/portabilidad/formulario',
        component: () => import('./views/portability/index.vue'), 
        meta: { title: "Portabilidad" },
        children: [
            {
                path: 'formulario',
                name: 'portabilityPageRoot',
                component: () => import('./views/portability/portability.vue'),
                meta: { title: 'Portabilidad' }
            },
            {
                path: 'que-es',
                name: 'portabilityPageInfo',
                component: () => import('./views/portability/info.vue'),
                meta: { title: '¿Qué es? | Portabilidad' }
            },
            {
                path: 'pasos-para-la-portabilidad',
                name: 'portabilityPageSteps',
                component: () => import('./views/portability/steps.vue'),
                meta: { title: 'Pasos para la portabilidad | Portabilidad' }
            },
            {
                path: 'preguntas-frecuentes',
                name: 'portabilityPageFAQs',
                component: () => import('./views/portability/faqs.vue'),
                meta: { title: 'Preguntas frecuentes | Portabilidad' }
            },
            {
                path: 'enviado',
                name: 'portabilityPageSent',
                component: () => import('./views/portability/form-sent.vue'),
                meta: { title: 'Portabilidad | Portabilidad' }
            },
        ]
    },
    {
        path: '*',
        redirect: '/home',
        component: () => import('./views/NotFound.vue'),
    }
];

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});